module.exports = __webpack_public_path__ + "img/homecontrol-en.2f44f8d2.png";